import type { EventConfig, SessionTypeConfig } from '../types/event';

/**
 * Default session categories for new events.
 *
 * `defaultAudienceId` is null here because the per-event role audiences
 * (All Invitees, All Internal Team, etc.) are bootstrapped per event via
 * `onEventCreatedBootstrapAudiences` and have IDs of the form
 * `{eventId}_{slug}` — not knowable at constant-definition time.
 * Authoring surfaces with a known event ID can fill these in as default
 * audiences.
 */
export const DEFAULT_SESSION_TYPES: SessionTypeConfig[] = [
  {
    id: 'presentation',
    name: 'Presentation',
    backgroundColor: '#076342',
    textColor: '#FFFFFF',
    iconName: 'Presentation',
    defaultAudienceId: null,
  },
  {
    id: 'meal',
    name: 'Meal',
    backgroundColor: '#124777',
    textColor: '#FFFFFF',
    iconName: 'Utensils',
    defaultAudienceId: null,
  },
  {
    id: 'activity',
    name: 'Activity',
    backgroundColor: '#4e4890',
    textColor: '#FFFFFF',
    iconName: 'Mountain',
    defaultAudienceId: null,
  },
  {
    id: 'breakout',
    name: 'Breakout',
    backgroundColor: '#7a283b',
    textColor: '#FFFFFF',
    iconName: 'Users',
    defaultAudienceId: null,
  },
];

/** Default EventConfig for new events. */
export const DEFAULT_EVENT_CONFIG: EventConfig = {
  agendaLabel: null,
  myScheduleLabel: null,
  speakersLabel: null,
  sessionsLabel: null,

  sessionTypes: DEFAULT_SESSION_TYPES,
  faqs: [],
};
